/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetDailyActivityMonitoringLogConcernsIssues = zod.object({
  "id": zod.string().uuid().optional()
});

export type GetDailyActivityMonitoringLogConcernsIssues = zod.input<typeof GetDailyActivityMonitoringLogConcernsIssues>;
export type GetDailyActivityMonitoringLogConcernsIssuesOutput = zod.output<typeof GetDailyActivityMonitoringLogConcernsIssues>;
